import Collapse from '@material-ui/core/Collapse';
import Add from "@material-ui/icons/Add";
import { useEffect, useState } from "react";
import EventListenerForm from "../../components/EventListener/EventListenerForm";
import Button from "../../components/UI/Button/Button";
import Input from "../../components/UI/Input/Input";
import Search from "../../components/UI/Search/Search";
import Spinner from "../../components/UI/Spinner/Spinner";
import Table from "../../components/UI/Table/Table";
import FetchData from "../../shared/fetchData";
import { checkValidity, updateObject } from "../../shared/utility";
import "./EventListeners.css";

const EventListeners = (props) => {

    const [eventListeners, setEventListeners] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [eventListenerId, setEventListenerId] = useState('');
    const [edit, setEdit] = useState(false);
    const [rerender, setRerender] = useState(false)
    const [pageSize, setPageSize] = useState(10)
    const [pageIndex, setPageIndex] = useState(0)
    const [pageCount, setPageCount] = useState(0)
    const [tableData, setTableData] = useState([])
    const [search, setSearch] = useState({
        cellNumber: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'تلفن همراه'
            },
            validation: {
                // required: true
            },
            errorMessage: 'فیلد اجباری',
            valid: true,
            value: ''
        }
    });
    useEffect(() => {
        setPageIndex(0)
        setPageSize(10)
        setPageCount(0)
    }, [])
    const getData = (pagination, isRefresh) => {
        setPageIndex(pagination.pageIndex)
        setPageSize(pagination.pageSize)
        setLoading(true);
        var url = 'management/api/v1/eventlisteners/getEventListeners'
        var raw = !!isRefresh && isRefresh ? JSON.stringify({
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        }) : JSON.stringify({
            "eventListener": {
                "cellNumber": search.cellNumber.value,
            },
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/eventlisteners/getEventListeners'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    let newList = []
                    for (let i = 0; i < (pagination.pageIndex * pagination.pageSize); i++) {
                        newList.push([]);
                    }
                    newList = newList.concat(result.eventListeners)
                    pushData(newList)
                    setEventListeners(newList)
                    setPageCount(result.count)
                    setLoading(false);
                } else {
                    setLoading(false)
                }
            })
            .catch(error => setLoading(false))
    }
    const pushData = (data) => {
        const rows = [];
        const headers = [
            {
                accessorKey: 'cellNumber',
                header: 'تلفن همراه',
                align: 'center',
            },
            {
                accessorKey: 'eventTypeDescription',
                header: 'نوع رویداد',
                align: 'center',
            },
            {
                accessorKey: 'text',
                header: 'متن پیامک',
                align: 'center',
            },
        ];
        const buttons = [];
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        data.map(d => {
            rows.push({
                id: d.id,
                cellNumber: d.cellNumber,
                eventTypeDescription: d.eventTypeDescription,
                text: d.text,
            });
        })
        buttons.push({ id: 1, text: 'ویرایش', clicked: editEventListener });
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        setRerender(!rerender);
    }
    const refresh = (event) => {
        setLoading(true)
        const srch = search;
        for (let key in srch) {
            srch[key].value = ''
        }
        setSearch(srch);
        getData({ pageIndex: pageIndex, pageSize: pageSize }, true)
    }
    const searchFn = (event) => {
        getData({ pageIndex: pageIndex, pageSize: pageSize })
    }
    const inputChangedHandler = (event, controlName) => {
        const updatedControls = updateObject(search, {
            [controlName]: updateObject(search[controlName], {
                value: event.target.value,
                valid: checkValidity(event.target.value, search[controlName].validation)
            })
        });
        setSearch(updatedControls);
    }

    const addNewEventListener = (event) => {
        setEdit(false);
        setShowForm(true);
    }

    const editEventListener = (id) => {
        setEdit(true);
        setEventListenerId(id);
        setShowForm(true);
    }

    const formElementsArray = [];
    for (let key in search) {
        formElementsArray.push({
            id: key,
            config: search[key]
        });
    }
    let form = formElementsArray.map(formElement => {
        let className = '4 mt-3'
        if (formElement.id == 'comment') {
            className = '12 mt-3'
        }
        return (
            <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                placeholder={formElement.config.placeholder}
                errorMessage={formElement.config.errorMessage}
                col={className}
                changed={(event) => inputChangedHandler(event, formElement.id)} />
        );
    });
    form = <div>
        <div className="row pl-4" dir="ltr" style={{ height: '0px' }}>
            <Button btnType="Refresh" clicked={refresh}></Button>
        </div>
        <div className="row small-acc-srch">
            {form}
        </div>
        <div className="row pl-3 mt-3" dir="ltr" >
            <Button btnType="Search" clicked={searchFn}>جستجو</Button>
        </div>
    </div>
    const add = <div className="plgn-add-btn">
        <div onClick={addNewEventListener} className="Add">
            <Add className="add-evnt-btn" />
        </div>
    </div>

    return (
        <>
            {loading ? <Spinner /> : ''}
            <Collapse in={!showForm} >
                <Search class="franchises-search" form={form} />
                <div className="row justify-content-center mt-3 w-100 ml-0 mb-2">{add}</div>
                {rerender ?
                    // <Spinner />
                    <Table hasDetails={false} pageSize={pageSize} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={170} loading={loading} />
                    :
                    <Table hasDetails={false} pageSize={pageSize} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={170} loading={loading} />
                }
            </Collapse>
            <Collapse in={showForm} >
                <EventListenerForm backToGridAndUpdate={(event) => {
                    setShowForm(false);
                    searchFn(event);
                }} backToGrid={() => { setShowForm(false) }} edit={edit} eventListenerId={eventListenerId} />
            </Collapse>
        </>
    )
}

export default EventListeners;